<template>
    <div class="MeusDados" >
        <b-modal ref="modal-meus-dados" body-class="m-modal-body" id="modalMeusDados" size="lg" :hide-footer="true" :hide-header="true" content-class="wrapper top-flashlight leftside light-xl" modal-class="rbt-modal-box share-modal" centered>
            <h5 class="title">Preencha os campos abaixo, e realize a alteração dos seus dados.</h5>
            <button class="close-button" data-bs-dismiss="modal" @click="close">
                <i class="feather-x"></i>
            </button>
            <div class="form p-3">
                <form class="" id="formMeusDados">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <h6 for="exampleInputEmail1">Nome</h6>
                                <input type="text" id="Usuarios_nmUsuario" name="usuario.nmUsuario" v-model="usuario.nmUsuario" maxlength="100" required>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <h6 for="dsEmail">E-mail</h6>
                                <input type="email" id="Usuarios_dsEmail" name="usuario.dsEmail" v-model="usuario.dsEmail" maxlength="100" required>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <h6 for="dsTelefone">Telefone</h6>
                                <vue-mask id="Usuarios_dsTelefone"
                                          name="usuario.dsTelefone"
                                          v-model="usuario.dsTelefone"
                                          mask="(00) 00000-0000"
                                          :raw="false"
                                          required>
                                </vue-mask>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <h6 for="dsEmail">Celular</h6>
                                <vue-mask id="Usuarios_dsCelular"
                                          name="usuario.dsCelular"
                                          v-model="usuario.dsCelular"
                                          mask="(00) 00000-0000"
                                          :raw="false"
                                          required>
                                </vue-mask>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <h6 for="dtNascimento">Data de Nascimento</h6>
                                <vue-mask id="dtNascimento"
                                          name="usuario.dtNascimento"
                                          v-model="usuario.dtNascimento"
                                          mask="00/00/0000"
                                          :raw="false"
                                          :options="options" required>
                                </vue-mask>
                            </div>
                        </div>
                    </div>

                    <button class="btn-default bg-solid-primary w-100 mt-5" type="button" :disabled="!liberaSalvar" @click="enviar">SALVAR ATUALIZAÇÕES</button>
                </form>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import vueMask from 'vue-jquery-mask'
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'MeusDados',
        components: {
            vueMask,
        },
        data: function () {
            return {

                limiteCaracteres: 500,

                usuario: {
                    nmUsuario: null,
                    dsEmail: null,
                    dsTelefone: null,
                    dsCelular: null,
                    dtNascimento: null,
                },

                options: {
                    placeholder: '__/__/____',
                },
            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {
            liberaSalvar() {
                if (this.usuario.nmUsuario == '' || this.usuario.nmUsuario == null) {
                    return false;
                }

                if (this.usuario.dsEmail == '' || this.usuario.dsEmail == null) {
                    return false;
                }

                if (this.usuario.dsTelefone == '' || this.usuario.dsTelefone == null) {
                    return false;
                }

                if (this.usuario.dsCelular == '' || this.usuario.dsCelular == null) {
                    return false;
                }

                if (this.usuario.dtNascimento == '' || this.usuario.dtNascimento == null) {
                    return false;
                }

                return true;
            },

            user() {
                return this.$store.state.user
            },

        },        
        methods: {
            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Auth/AlteraDados`, $this.usuario)
                        .then(res => {
                            if (res.data.success) {
                                // aviso ok
                                avisoSucesso("Dados alterados com sucesso!");
                                $this.$refs['modal-meus-dados'].hide();
                                $this.getDadosUser();
                            } else {
                                avisoErro("Não foi possível alterar seus dados.");
                            }
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                avisoErro(res.response.data);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }
                return false;
            },

            getDadosUser() {
                let $this = this;
                axios.get(`${urlApi}/Auth/GetDadosUser`)
                    .then(res => {
                        if (res.data.success) {
                            $this.$store.commit('setUsuario', res.data.data.usuario);
                        } else {
                            avisoErro("Não foi possível carregar seus dados.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar seus dados.");
                        }
                    });
            },

            checkForm() {
                var form = document.getElementById('formMeusDados')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                if (this.limiteCaracteres > 0) {
                    if (this.usuario.nmUsuario.length > 100) {
                        avisoErro("O limite de caracteres do \"Nome\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsEmail.length > 100) {
                        avisoErro("O limite de caracteres \"E-mail\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsTelefone.length > 100) {
                        avisoErro("O limite de caracteres \"Telefone\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsCelular.length > 100) {
                        avisoErro("O limite de caracteres \"Celular\" foi ultrapassado")
                        return false;
                    }
                }

                return true;
            },

            load() {
                var user = this.user.usuario;
                this.usuario = {
                    nmUsuario: user.nmUsuario,
                    dsEmail: user.dsEmail,
                    dsTelefone: user.dsTelefone,
                    dsCelular: user.dsCelular,
                    dtNascimento: moment(user.dtNascimento).format('DD/MM/YYYY'),
                };
            },

            close() {
                this.$refs['modal-meus-dados'].hide();
            }

        },
        created: function () {
            this.load();
        },
        watch: {
            showModal: function () {
                this.$refs['modal-meus-dados'].show();
                this.load();
            },
            
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css">
    /* Modal meus dados */
   .form-control {
        border: 1px solid #474747;
    }

    /* declarado na app */
    /*.m-modal-body {
        position: unset !important;
    }*/

</style>

